import business from "./businessInfo.json";

export const BUSINESS = business;

export function getPostalAddressSchema() {
  return {
    "@type": "PostalAddress",
    streetAddress: BUSINESS.streetAddress,
    addressLocality: BUSINESS.addressLocality,
    addressRegion: BUSINESS.addressRegion,
    postalCode: BUSINESS.postalCode,
    addressCountry: BUSINESS.addressCountry,
  };
}

export function getSameAsUrls() {
  return BUSINESS.socialLinks.map((link) => link.href);
}

export function getUdyamIdentifierSchema() {
  return {
    "@type": "PropertyValue",
    propertyID: "UDYAM",
    name: "UDYAM Registration Number",
    value: BUSINESS.udyamRegistration,
  };
}

export function getOrganizationSchema({
  url,
  description,
  sameAs = [],
  knowsAbout = [],
}) {
  return {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: BUSINESS.tradeName,
    legalName: BUSINESS.legalName,
    url,
    email: BUSINESS.email,
    telephone: BUSINESS.phone,
    description,
    areaServed: "IN",
    address: getPostalAddressSchema(),
    identifier: getUdyamIdentifierSchema(),
    ...(knowsAbout.length > 0 ? { knowsAbout } : {}),
    ...(sameAs.length > 0 ? { sameAs } : {}),
  };
}

export function getLocalBusinessSchema({
  url,
  description,
  sameAs = [],
  contactPoint,
}) {
  return {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    name: BUSINESS.tradeName,
    legalName: BUSINESS.legalName,
    url,
    email: BUSINESS.email,
    telephone: BUSINESS.phone,
    description,
    address: getPostalAddressSchema(),
    identifier: getUdyamIdentifierSchema(),
    ...(sameAs.length > 0 ? { sameAs } : {}),
    ...(contactPoint ? { contactPoint } : {}),
  };
}
